import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HealthcareLiabilityComponent } from './healthcare-liability/healthcare-liability.component';
import { UWSummaryComponent } from './uw/uwsummary/uwsummary.component';
import { UWDetailComponent } from './uw/uwdetail/uwdetail.component';
import { AcordSummaryComponent } from './uw/acord-summary/acord-summary.component';
import { AcordDetailComponent } from './uw/acord-detail/acord-detail.component';
import { GlEiTopClaimsComponent } from './visualizations/gl-ei-top-claims/gl-ei-top-claims.component';
import { HomeComponent } from './home/home.component';
// import { ProfileComponent } from './profile/profile.component';
import { WorkflowSummaryComponent } from './workflow/workflow-summary/workflow-summary.component';
import { WorkflowDetailComponent } from './workflow/workflow-detail/workflow-detail.component';
// import { WorkflowComponent } from './workflow/workflow/workflow.component';
import { AuthGuard } from './auth/auth.guard';
import {GlEiSameEffortComponent} from './visualizations/gl-ei-same-effort/gl-ei-same-effort.component';


// , canActivate: [AuthGuard]
const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full'},
  { path: 'home', component: HomeComponent },
  { path: 'healthcare', component: HealthcareLiabilityComponent, canActivate: [AuthGuard],
    data: {allowedRoles: ['admin', 'healthcare']}},
  { path: 'uw',
    children: [
      {path: 'acord', data: { allowedRoles: ['admin', 'acord']}, canActivate: [AuthGuard],
        children: [
          {path: '', component: AcordSummaryComponent, data: { breadcrumb: 'summary'}},
          {path: ':id', component: AcordDetailComponent, data: { breadcrumb: 'detail'}}
        ]},
      {path: 'rts', children: [
          {path: '', component: UWSummaryComponent},
          {path: ':id', component: UWDetailComponent}
        ]}
    ]},
  { path: 'visualizations',
    children: [
      { path: 'gl-ei-top-claims', component: GlEiTopClaimsComponent, data: { allowedRoles: ['admin', 'sales']},
        canActivate: [AuthGuard]},
      { path: 'gl-ei-same-effort', component: GlEiSameEffortComponent, data: { allowedRoles: ['admin', 'sales']},
        canActivate: [AuthGuard]}
    ]
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

